import isArray from "lodash/isArray";
import memoize from "lodash/memoize";
import flattenDeep from "lodash/flattenDeep";
import chroma from "chroma-js";
const getTextColor = _ref => {
  let {
    colors
  } = _ref;
  return memoize(path => {
    path = isArray(path) ? flattenDeep(path).join(".") : path;
    let hue,
      shade = "main",
      shadeAdjust = 0;
    let parts = path.split(".");
    parts.forEach(part => {
      if (/^(\d+|main)$/.test(part)) {
        shade = part;
      } else if (/^([+-]\d+)$/.test(part)) {
        shadeAdjust += Number(part.replace("+", ""));
      } else if (colors[part]) {
        hue = colors[part];
      } else if (chroma.valid(part)) {
        hue = part;
      } else if (part === "transparent") {
        hue = "#0000";
      } else if (part === "currentColor" || part === "inherit") {
        hue = part;
      }
    });
    let luminance;
    if (!isNaN(shade)) {
      luminance = 100 - shade / 10;
    } else if (typeof hue === "string" && chroma.valid(hue)) {
      luminance = chroma(hue).get("hcl.l");
    } else if (typeof hue === "object" && (hue == null ? void 0 : hue.main)) {
      luminance = chroma(hue.main).get("hcl.l");
    }
    if (luminance == null) {
      return null;
    }
    luminance -= shadeAdjust / 10;
    return luminance > 50 ? "#000" : "#fff";
  }, path => isArray(path) ? flattenDeep(path).join(".") : path);
};
export { getTextColor as default };